import Avatar from '../Avatar';

const OVERFLOW_SIZE_CLASSES = {
  xxs: 'h-6 w-6 text-[10px]',
  xs: 'h-9 w-9 text-xs',
  sm: 'h-10 w-10 text-xs',
};

/**
 * Overlapping avatar cluster for group-scoped people.
 *
 * sizePx + overlapPx override the token size when a screen needs exact pixels
 * (e.g. 38px reveal stack with -10px overlap, 20px voter stacks with -7px).
 */
export default function GroupAvatarStack({
  people = [],
  max = 5,
  size = 'xxs',
  sizePx = null,
  overlapPx = -8,
  showOverflow = true,
  className = '',
}) {
  if (people.length === 0) return null;

  const shown = people.slice(0, max);
  const overflow = people.length - shown.length;
  const pxStyle = sizePx ? { width: sizePx, height: sizePx } : null;
  const overflowSize = sizePx
    ? { width: sizePx, height: sizePx, fontSize: Math.max(9, Math.round(sizePx * 0.32)) }
    : null;

  return (
    <div className={`flex shrink-0 ${className}`} aria-hidden>
      {shown.map((person, i) => (
        <div
          key={person.id}
          // no ring of its own: the face carries its color ring
          className="relative shrink-0 rounded-full"
          style={{ zIndex: i, marginLeft: i > 0 ? overlapPx : 0, ...pxStyle }}
        >
          <Avatar
            displayName={person.display_name}
            profilePhotoUrl={person.profile_photo_url}
            size={size}
            className={sizePx ? '!w-full !h-full' : ''}
          />
        </div>
      ))}
      {showOverflow && overflow > 0 && (
        <div
          className={`relative flex shrink-0 items-center justify-center rounded-full bg-white/15 font-semibold text-ink ring-2 ring-inset ring-white/25 ${
            !sizePx ? (OVERFLOW_SIZE_CLASSES[size] ?? OVERFLOW_SIZE_CLASSES.xxs) : ''
          }`}
          style={{
            zIndex: shown.length,
            marginLeft: overlapPx,
            ...(overflowSize || {}),
          }}
        >
          +{overflow}
        </div>
      )}
    </div>
  );
}
